export const commonConfig = {
  darkTheme: true,
};
